/**
 * Checks if an object is iterable or not
 * @param {any} obj object to test
 * @returns {boolean} whether or not the object is iterable
 */
export function isIterable(obj) {
  // checks for null and undefined
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === "function";
}
